import { useState, useEffect, useCallback } from 'react';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import SearchableSelect from '../../components/common/SearchableSelect';
import StatusBadge from '../../components/common/StatusBadge';
import * as api from '../../api/areas';
import * as clientesApi from '../../api/clientes';

function Modal({ item, idClienteFinal, onClose, onSaved }) {
  const editando = !!item?.id_area_cliente;
  const [nome, setNome] = useState(item?.nome || '');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const salvar = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      if (editando) await api.atualizar(item.id_area_cliente, { nome });
      else await api.criar({ nome, id_cliente_final: idClienteFinal });
      onSaved();
    } catch (err) {
      const d = err.response?.data?.detail;
      setErro(typeof d === 'string' ? d : 'Erro ao salvar.');
    } finally { setLoading(false); }
  };

  const toggleAtivo = async () => {
    setLoading(true);
    try {
      await api.atualizar(item.id_area_cliente, { ativo: !item.ativo });
      onSaved();
    } finally { setLoading(false); }
  };

  return (
    <div className="modal show d-block" style={{ background: 'rgba(0,0,0,.45)' }}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title mb-0">{editando ? 'Editar Área' : 'Nova Área'}</h5>
            <button className="btn-close" onClick={onClose} />
          </div>
          <form onSubmit={salvar}>
            <div className="modal-body">
              {erro && <div className="alert alert-danger py-2">{erro}</div>}
              <label className="form-label fw-semibold">Nome *</label>
              <input className="form-control" value={nome} onChange={e => setNome(e.target.value)} required autoFocus
                placeholder="Ex: Administrativo, Almoxarifado, Filial SP..." />
            </div>
            <div className="modal-footer d-flex justify-content-between">
              {editando ? (
                <button type="button" className={`btn btn-sm ${item.ativo ? 'btn-outline-danger' : 'btn-outline-success'}`}
                  onClick={toggleAtivo} disabled={loading}>
                  {item.ativo ? 'Desativar' : 'Ativar'}
                </button>
              ) : <span />}
              <div className="d-flex gap-2">
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-primary btn-sm" disabled={loading}>
                  {loading ? <span className="spinner-border spinner-border-sm" /> : 'Salvar'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default function Areas() {
  const [clientes, setClientes] = useState([]);
  const [idClienteFinal, setIdClienteFinal] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [erroCarregar, setErroCarregar] = useState('');

  useEffect(() => {
    clientesApi.listar().then(r => setClientes(r.data)).catch(() => {});
  }, []);

  const carregar = useCallback(() => {
    if (!idClienteFinal) { setItems([]); setLoading(false); return; }
    setLoading(true);
    setErroCarregar('');
    api.listar(idClienteFinal)
      .then(r => setItems(r.data))
      .catch(() => setErroCarregar('Erro ao carregar áreas.'))
      .finally(() => setLoading(false));
  }, [idClienteFinal]);

  useEffect(() => { carregar(); }, [carregar]);

  const clienteOpts = clientes.map(c => ({ value: c.id_cliente_final, label: c.nome }));

  return (
    <div>
      <PageHeader titulo="Áreas" subtitulo="Departamentos/filiais internos de cada cliente">
        {idClienteFinal && (
          <button className="btn btn-primary btn-sm" onClick={() => setModal({})}>+ Nova Área</button>
        )}
      </PageHeader>

      <div className="mb-3" style={{ maxWidth: 360 }}>
        <label className="form-label fw-semibold" style={{ fontSize: 13 }}>Cliente</label>
        <SearchableSelect options={clienteOpts} value={idClienteFinal}
          onChange={setIdClienteFinal} placeholder="Selecione o cliente..." />
      </div>

      {erroCarregar && <div className="alert alert-danger py-2">{erroCarregar}</div>}

      {!idClienteFinal ? (
        <p className="text-muted">Selecione um cliente para ver/gerenciar as áreas dele.</p>
      ) : loading ? <LoadingSpinner /> : (
        <div className="card">
          <div className="card-body p-0">
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Status</th>
                  <th style={{ width: 60 }}></th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 && (
                  <tr><td colSpan={3} className="text-center text-muted py-4">Nenhuma área cadastrada.</td></tr>
                )}
                {items.map(a => (
                  <tr key={a.id_area_cliente}>
                    <td className="fw-semibold">{a.nome}</td>
                    <td><StatusBadge status={a.ativo ? 'ativo' : 'inativo'} /></td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary py-0 px-2"
                        onClick={() => setModal(a)}>Editar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {modal !== null && (
        <Modal item={modal} idClienteFinal={idClienteFinal}
          onClose={() => setModal(null)} onSaved={() => { setModal(null); carregar(); }} />
      )}
    </div>
  );
}
